var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import VerticalFilterTabs from "@frameworks/shared-library/components/VerticalFilterTabs/VerticalFilterTabs";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import TextFirstAlphabetAsIcon from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/TextFirstAlphabetAsIcon";
import filterDI from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import BasicErrorMessage from "@frameworks/shared-library/components/BasicErrorMessage/BasicErrorMessage";
import { randomColorArr } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import { EDataSource, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import debounce from "@frameworks/web/utils/debounce";
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import aopOrderBookDI from "./di/servicelocator";
import { getDateInFormat } from "@domains/utils/reportDates";
import { useSelector } from "react-redux";
import { toCamelCase } from "@domains/utils/stringMethods";
import moment from "moment";
var AOP_Investment_Filters = function (props) {
    var _a = __read(React.useState("accountType"), 2), activeTabKey = _a[0], setActiveTabKey = _a[1];
    var _b = __read(React.useState(""), 2), searchedClient = _b[0], setSearchedClient = _b[1];
    var _c = __read(React.useState(false), 2), loader = _c[0], setLoader = _c[1];
    var _d = __read(React.useState((props === null || props === void 0 ? void 0 : props.filterData)
        ? props === null || props === void 0 ? void 0 : props.filterData
        : {
            accountTypeId: ["2"],
            fromDate: moment().startOf("month").format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
            pageStart: 0,
            pageSize: 10,
            isFilter: true,
            inputEmpId: [],
            inputClientCode: [],
        }), 2), filterData = _d[0], setFilterData = _d[1];
    var _e = __read(React.useState([
        {
            display: "Investment Account",
            value: 2,
        },
    ]), 2), accountFilterData = _e[0], setAccountFilterData = _e[1];
    var _f = __read(React.useState([]), 2), rmNameFilterData = _f[0], setRMNameData = _f[1];
    var _g = __read(React.useState([]), 2), clientNameFilterData = _g[0], setClientNameData = _g[1];
    var _h = __read(React.useState([]), 2), originalClientNameFilterData = _h[0], setOriginalClientNameFilterData = _h[1];
    var profileData = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.Profile) === null || _a === void 0 ? void 0 : _a.ProfileDetails) === null || _b === void 0 ? void 0 : _b.reducersData) === null || _c === void 0 ? void 0 : _c.data; });
    var handleFilterDataEvents = function (e, isCheckBox, callBackFunction) {
        var _a, _b, _c;
        var localFilterData = __assign({}, filterData);
        if (isCheckBox) {
            if ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.checked) {
                if (localFilterData[e.target.name] ===
                    undefined ||
                    localFilterData[e.target.name] ===
                        null) {
                    localFilterData[e.target.name] =
                        [];
                }
                (_b = localFilterData[e.target.name]) === null || _b === void 0 ? void 0 : _b.push(e.target.value);
                if (!!callBackFunction) {
                    callBackFunction();
                }
            }
            else {
                localFilterData[e.target.name] = (_c = localFilterData[e.target.name]) === null || _c === void 0 ? void 0 : _c.filter(function (item) { return item !== e.target.value; });
            }
        }
        setFilterData(localFilterData);
        props === null || props === void 0 ? void 0 : props.setRetainedFilterData(localFilterData);
    };
    var getRmFiltersData = function (searchText) {
        setLoader(true);
        var reqObj = {
            filterData: { teamType: [1, 2], dataSource: EDataSource.RM, rmId: [] },
            page: "0",
            pageSize: "100",
        };
        if (!!searchText && searchText !== "")
            reqObj.searchText = searchText;
        filterDI.filter
            .getFilterDataActions(reqObj)
            .then(function (resp) {
            var _a, _b;
            if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.filterData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                if (!!profileData &&
                    !!(profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) &&
                    !!((_b = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _b === void 0 ? void 0 : _b.userId)) {
                    setFilterData(function (filterData) {
                        var _a, _b;
                        if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) === null ||
                            (filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) === undefined) {
                            filterData.inputEmpId = [];
                        }
                        filterData.inputEmpId.push((_b = (_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId) === null || _b === void 0 ? void 0 : _b.toString());
                        var newSet = new Set(filterData.inputEmpId);
                        filterData.inputEmpId = __spreadArray([], __read(newSet), false);
                        return filterData;
                    });
                }
                setRMNameData(function () {
                    var _a;
                    return (_a = resp === null || resp === void 0 ? void 0 : resp.filterData) === null || _a === void 0 ? void 0 : _a.map(function (filterObj) {
                        return {
                            display: filterObj === null || filterObj === void 0 ? void 0 : filterObj.name,
                            value: filterObj === null || filterObj === void 0 ? void 0 : filterObj.id,
                        };
                    });
                });
            }
            else {
                setRMNameData([]);
            }
            setLoader(false);
        })
            .catch(function (resp) {
            setRMNameData([]);
            setLoader(false);
        });
    };
    var getAOPClientFilterData = function (stopLoader) {
        var empId = "";
        if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) !== undefined) {
            empId = filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId.filter(function (item) { return item !== undefined && item !== null; }).join(",");
        }
        var reqObj = {
            fromDate: getDateInFormat(filterData === null || filterData === void 0 ? void 0 : filterData.fromDate, "yyyy-MM-DD"),
            toDate: getDateInFormat(filterData === null || filterData === void 0 ? void 0 : filterData.toDate, "yyyy-MM-DD"),
            accountTypeId: "2",
            inputEmpId: empId,
            encryption: true,
        };
        aopOrderBookDI.aopOrderBook
            .getAOPOrderBookClientFilterList(reqObj)
            .then(function (resp) {
            var _a;
            if (resp && ((_a = resp === null || resp === void 0 ? void 0 : resp.aopOrderBookClientList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setClientNameData(function () {
                    var _a;
                    return (_a = resp === null || resp === void 0 ? void 0 : resp.aopOrderBookClientList) === null || _a === void 0 ? void 0 : _a.map(function (filterObj) {
                        setFilterData(function (filterData) {
                            var _a, _b, _c, _d, _e;
                            if (!!(props === null || props === void 0 ? void 0 : props.retainedFilters) &&
                                !!((_a = props === null || props === void 0 ? void 0 : props.retainedFilters) === null || _a === void 0 ? void 0 : _a.inputClientCode) &&
                                ((_c = (_b = props === null || props === void 0 ? void 0 : props.retainedFilters) === null || _b === void 0 ? void 0 : _b.inputClientCode) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                                (_d = props === null || props === void 0 ? void 0 : props.retainedFilters) === null || _d === void 0 ? void 0 : _d.inputClientCode.map(function (recor) {
                                    var _a, _b;
                                    if (recor == ((_a = filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientcode) === null || _a === void 0 ? void 0 : _a.toString())) {
                                        if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode) == null ||
                                            (filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode) == undefined) {
                                            filterData.inputClientCode = [];
                                        }
                                        filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode.push((_b = filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientcode) === null || _b === void 0 ? void 0 : _b.toString());
                                        var newSet = new Set(filterData.inputClientCode);
                                        filterData.inputClientCode = __spreadArray([], __read(newSet), false);
                                    }
                                });
                            }
                            else {
                                if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode) == null ||
                                    (filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode) == undefined) {
                                    filterData.inputClientCode = [];
                                }
                                filterData.inputClientCode.push((_e = filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientcode) === null || _e === void 0 ? void 0 : _e.toString());
                                var newSet = new Set(filterData.inputClientCode);
                                filterData.inputClientCode = __spreadArray([], __read(newSet), false);
                            }
                            return filterData;
                        });
                        return {
                            display: toCamelCase(filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientname),
                            value: filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientcode,
                        };
                    });
                });
                setOriginalClientNameFilterData(function () {
                    var _a;
                    return (_a = resp === null || resp === void 0 ? void 0 : resp.aopOrderBookClientList) === null || _a === void 0 ? void 0 : _a.map(function (filterObj) {
                        return {
                            display: toCamelCase(filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientname),
                            value: filterObj === null || filterObj === void 0 ? void 0 : filterObj.clientcode,
                        };
                    });
                });
            }
        })
            .catch(function () {
            setClientNameData([]);
        });
    };
    var handleApplyFilters = function () {
        props === null || props === void 0 ? void 0 : props.setFiltreLabelsUI(filterData);
        props === null || props === void 0 ? void 0 : props.handleApplyFilters(filterData, true);
    };
    var selectAllFunctionality = function (selectALl, name, filtersData) {
        var localFilterData = __assign({}, filterData);
        if (!!selectALl && selectALl) {
            localFilterData[name] = [];
        }
        else {
            if (filtersData && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) > 0) {
                var localArry = filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (record) {
                    var _a;
                    return typeof (record === null || record === void 0 ? void 0 : record.value) == "number"
                        ? (_a = record === null || record === void 0 ? void 0 : record.value) === null || _a === void 0 ? void 0 : _a.toString()
                        : record === null || record === void 0 ? void 0 : record.value;
                });
                if (!!localArry && localArry && (localArry === null || localArry === void 0 ? void 0 : localArry.length) > 0) {
                    localFilterData[name] = localArry;
                }
            }
        }
        setFilterData(localFilterData);
    };
    var handleSearchClientsInFilters = function (searchedText, name) {
        setSearchedClient(searchedText);
        switch (name) {
            case "inputEmpId":
                // setRMNameData([]);
                debounce(function () {
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            getRmFiltersData(searchedText);
                            return [2 /*return*/];
                        });
                    });
                }, 100)();
                break;
            case "inputClientCode":
                searchClientFilterData(searchedText);
                break;
            default:
                break;
        }
    };
    var searchInArray = function (arr, searchText, possibleKeys) {
        var localArray = arr.filter(function (obj) {
            // Create a mapped array of boolean values, checking if each key contains the searchTerm
            var matches = possibleKeys.map(function (key) {
                return obj[key] &&
                    obj[key].toString().toLowerCase().includes(searchText.toLowerCase());
            });
            // Return true if any of the keys match
            return matches.some(function (match) { return match; });
        });
        return localArray;
    };
    var searchClientFilterData = function (searchText) {
        setLoader(true);
        if (searchText !== "" && !!searchText) {
            setTimeout(function () {
                var localClientNameArray = clientNameFilterData;
                if ((clientNameFilterData === null || clientNameFilterData === void 0 ? void 0 : clientNameFilterData.length) > 0) {
                    localClientNameArray = originalClientNameFilterData;
                }
                localClientNameArray = searchInArray(clientNameFilterData, searchText, [
                    "display",
                    "value",
                ]);
                setClientNameData(localClientNameArray);
                setLoader(false);
            }, 200);
        }
        else {
            setClientNameData(originalClientNameFilterData);
            setLoader(false);
        }
    };
    var clearSearchingFilterFunction = function (name) {
        switch (name) {
            case "inputEmpId":
                getRmFiltersData();
                break;
            case "inputClientCode":
                setClientNameData(originalClientNameFilterData);
                break;
            default:
                break;
        }
    };
    var generateCheckboxFiltersForStatus = function (filtersData, selectedDataArr, key, showSearchClient, searchClientPlaceholder, callBackFunction) {
        return (React.createElement("div", { className: "d-flex flex-column order-status-checkbox-filters-container" },
            showSearchClient && (React.createElement(FundSearchPanel, { placeholder: searchClientPlaceholder
                    ? searchClientPlaceholder
                    : "Search by client name", applySearchedFilters: function (value) {
                    handleSearchClientsInFilters(value, key);
                }, disableDefaultDebounce: true, searchValue: searchedClient, clearSearching: function () {
                    clearSearchingFilterFunction(key);
                } })),
            React.createElement(EdButton, { btnTyp: "text-only", value: (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) === (selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.length)
                    ? "Deselect All"
                    : "Select All", className: "text-right p-10 txt-han-blue orderbook-summary-select-all-filters-btn", onClick: function () {
                    selectAllFunctionality((filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) === (selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.length), key, filtersData);
                } }),
            React.createElement("div", null,
                (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) > 0 &&
                    (filtersData === null || filtersData === void 0 ? void 0 : filtersData.map(function (item) {
                        var _a;
                        return (React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                                name: key ? key : "",
                                checked: selectedDataArr === null || selectedDataArr === void 0 ? void 0 : selectedDataArr.includes(typeof (item === null || item === void 0 ? void 0 : item.value) === "number"
                                    ? (_a = item === null || item === void 0 ? void 0 : item.value) === null || _a === void 0 ? void 0 : _a.toString()
                                    : item === null || item === void 0 ? void 0 : item.value),
                                value: item.value,
                                onChange: function (e) {
                                    handleFilterDataEvents(e, true, callBackFunction);
                                },
                            }, customLabel: getCustomLabel(key, item) }));
                    })),
                (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) === 0 && (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var getCustomLabel = function (key, item) {
        var _a, _b;
        var customLabel = "";
        switch (key) {
            case "inputEmpId":
                customLabel = (React.createElement("div", { className: "primary-client-names-with-client-codes-container d-flex align-items-center gap-10 ".concat("") },
                    " ",
                    React.createElement(TextFirstAlphabetAsIcon, { textToExtractWordFrom: item === null || item === void 0 ? void 0 : item.display, textAndBackgroundColorCollection: randomColorArr }),
                    React.createElement("div", { className: "d-flex flex-column" },
                        React.createElement("span", { className: "filter-label" }, item === null || item === void 0 ? void 0 : item.display),
                        React.createElement("span", { className: "aop-investment-filter-second-label" },
                            React.createElement("label", { className: "flilter-label-md" }, item.value),
                            " ",
                            React.createElement("i", { className: "edel-icon-round-circle" }),
                            " ",
                            React.createElement("label", { className: "flilter-label-rm" }, "RM")))));
                break;
            case "inputClientCode":
                customLabel = (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement("div", { className: "primary-client-names-with-client-codes-container d-flex align-items-center gap-10 ".concat("") },
                        " ",
                        React.createElement(TextFirstAlphabetAsIcon, { textToExtractWordFrom: item === null || item === void 0 ? void 0 : item.display, textAndBackgroundColorCollection: randomColorArr }),
                        React.createElement("div", { className: "d-flex flex-column" },
                            React.createElement("span", { className: "filter-label" }, item === null || item === void 0 ? void 0 : item.display),
                            React.createElement("span", { className: "aop-investment-filter-second-label" },
                                React.createElement("label", { className: "flilter-label-md" }, ((_a = String(item === null || item === void 0 ? void 0 : item.value)) === null || _a === void 0 ? void 0 : _a.endsWith("I"))
                                    ? (_b = String(item === null || item === void 0 ? void 0 : item.value)) === null || _b === void 0 ? void 0 : _b.slice(0, -1)
                                    : item === null || item === void 0 ? void 0 : item.value),
                                " ",
                                React.createElement("i", { className: "edel-icon-round-circle" }),
                                " ",
                                React.createElement("label", { className: "flilter-label-rm" }, "Client"))))));
                break;
            default:
                customLabel = (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMsanL_12_300 han-blue" }, item === null || item === void 0 ? void 0 : item.display)));
                break;
        }
        return customLabel;
    };
    var getAccountTypeUIContent = function () {
        return (React.createElement(React.Fragment, null, accountFilterData && (accountFilterData === null || accountFilterData === void 0 ? void 0 : accountFilterData.length) > 0 ? (React.createElement(React.Fragment, null, generateCheckboxFiltersForStatus(accountFilterData, filterData === null || filterData === void 0 ? void 0 : filterData.accountTypeId, "accountTypeId"))) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." }))));
    };
    var getRMNameUIContent = function () {
        return (React.createElement(React.Fragment, null, generateCheckboxFiltersForStatus(rmNameFilterData, filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId, "inputEmpId", true, "Search by RM Name", function () {
            getAOPClientFilterData(true);
        })));
    };
    var getClientNameUIContent = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(React.Fragment, null,
                React.createElement(React.Fragment, null, generateCheckboxFiltersForStatus(clientNameFilterData, filterData === null || filterData === void 0 ? void 0 : filterData.inputClientCode, "inputClientCode", true, "Search by Client Name")))));
    };
    var filterTabs = [
        {
            title: "Account Type",
            eventKey: "accountType",
            value: "accountType",
            disabled: false,
            tabContent: getAccountTypeUIContent(),
        },
        {
            title: "RM Name",
            eventKey: "rmName",
            value: "rmName",
            disabled: false,
            tabContent: getRMNameUIContent(),
        },
        {
            title: "Client Name",
            eventKey: "clientName",
            value: "clientName",
            disabled: false,
            tabContent: getClientNameUIContent(),
        },
    ];
    React.useEffect(function () {
        setFilterData(props === null || props === void 0 ? void 0 : props.filterData);
    }, [props === null || props === void 0 ? void 0 : props.filterData]);
    React.useEffect(function () {
        var _a;
        if (!!profileData &&
            !!(profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) &&
            !!((_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId)) {
            setFilterData(function (filterData) {
                var _a, _b;
                if ((filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) === null ||
                    (filterData === null || filterData === void 0 ? void 0 : filterData.inputEmpId) === undefined) {
                    filterData.inputEmpId = [];
                }
                filterData.inputEmpId.push((_b = (_a = profileData === null || profileData === void 0 ? void 0 : profileData.profileDetails) === null || _a === void 0 ? void 0 : _a.userId) === null || _b === void 0 ? void 0 : _b.toString());
                var newSet = new Set(filterData.inputEmpId);
                filterData.inputEmpId = __spreadArray([], __read(newSet), false);
                return filterData;
            });
        }
        getRmFiltersData();
        getAOPClientFilterData();
    }, []);
    return (React.createElement(VerticalFilterTabs, { defaultActiveKey: activeTabKey, handleTabChange: function (key) { return setActiveTabKey(key); }, tabsList: filterTabs, cancelBtnCallback: props === null || props === void 0 ? void 0 : props.handleCancelCallback, applyBtnCallback: function () {
            handleApplyFilters();
        }, clearAllBtnCallback: props === null || props === void 0 ? void 0 : props.handleClearAllCallback }));
};
export default AOP_Investment_Filters;
